import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import React from 'react';
import { isCampFreeOrNot } from '../../../utils/subscription.util';

const SpecialCampButtons = ({
  camp,
  dependent,
  handleConfirm,
  BuySpecialCamp,
  isSpecialCampAttend,
}) => {
  console.log(isSpecialCampAttend, 'special_camp_status')
  return (
    <Box
      sx={{
        maxWidth: 528,
        position: 'relative',
        margin: 'auto',
        mt: '40px',
        pb: '20px',
      }}
    >
      {!isCampFreeOrNot(camp, dependent) ? !camp.special_camp_status ? (
        <Button
          variant="contained"
          className="fullbtn"
          sx={{ borderRadius: '20px', width: '100%' }}
          onClick={() => BuySpecialCamp(camp)}
        >
          Buy Dream Camp
        </Button>
      ) : (
        <>
          <Typography
            variant="h4"
            sx={{
              fontSize: '20px',
              fontWeight: '700',
              lineHeight: '43.58px',
            }}
          >
            Attend Dream Camp?
          </Typography>

          <ButtonGroup
            color="primary"
            className="groupbtn"
            aria-label="radius button group"
            sx={{
              borderRadius: '50px',
              width: '100%',
            }}
          >
            <Button
              className="btn_hover"
              sx={{
                borderRadius: '50px',
                width: '100%',
                color: isSpecialCampAttend || !!camp?.special_camp_status ? '#fff' : '#321B6D',
                backgroundColor: isSpecialCampAttend || !!camp.special_camp_status  
                  ? '#321B6D'
                  : 'transparent',
                font: '16px',
                border: '0px',
                fontWeight: '700',
                pr: '2px',
                borderRight: '1px solid #ccc',
              }}
              disabled={isSpecialCampAttend || !!camp?.special_camp_status}
              onClick={() => handleConfirm('YES')}
            >
              yes
            </Button>
            <Button
              className="btn_hover"
              sx={{
                borderRadius: '50px',
                width: '100%',
                color: '#321B6D',
                border: '0px',
                font: '16px',
                fontWeight: '700',
                pl: '2px',
                borderLeft: '1px solid #ccc',
              }}
              onClick={() => handleConfirm('NO')}
            >
              No
            </Button>
          </ButtonGroup>
        </>
      ) : <>
        <Typography
          variant="h4"
          sx={{
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '43.58px',
          }}
        >
          Attend Dream Camp?
        </Typography>

        <ButtonGroup
          color="primary"
          className="groupbtn"
          aria-label="radius button group"
          sx={{
            borderRadius: '50px',
            width: '100%',
          }}
        >
          <Button
            className="btn_hover"
            sx={{
              borderRadius: '50px',
              width: '100%',
              color: isSpecialCampAttend || !!camp?.special_camp_status ? '#fff' : '#321B6D',
              backgroundColor: isSpecialCampAttend || !!camp?.special_camp_status
                ? '#321B6D'
                : 'transparent',
              font: '16px',
              border: '0px',
              fontWeight: '700',
              pr: '2px',
              borderRight: '1px solid #ccc',
            }}
            disabled={isSpecialCampAttend || !!camp?.special_camp_status}
            onClick={() => handleConfirm('YES')}
          >
            yes
          </Button>
          <Button
            className="btn_hover"
            sx={{
              borderRadius: '50px',
              width: '100%',
              color: '#321B6D',
              border: '0px',
              font: '16px',
              fontWeight: '700',
              pl: '2px',
              borderLeft: '1px solid #ccc',
            }}
            onClick={() => handleConfirm('NO')}
          >
            No
          </Button>
        </ButtonGroup>
      </>}
    </Box>
  );
};

export default SpecialCampButtons;
